import React from "react";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  field: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "15px 10px 0 10px",
    padding: "10px",
    backgroundColor: theme.palette.grey["50"],
  },

  inlineField: {
    flexDirection: "row",
  },

  fieldName: {
    fontWeight: "300",
    fontSize: "16px",
    color: theme.palette.grey.A400,
  },
}));

export default function RecipeField({ name, children, inline = false }: any) {
  const { classes, cx } = useStyles();

  return (
    <Paper
      elevation={2}
      className={cx(classes.field, { [classes.inlineField]: inline })}
    >
      <Typography className={classes.fieldName} variant="body2">
        {name}
        {inline && ":"}
      </Typography>
      {children}
    </Paper>
  );
}
